import { graphql } from '../../../gql';

// TRIL-377: device/session management (Settings → Devices). Backend = TRIL-375.
export const GET_MY_SESSIONS = graphql(`
  query mySessions {
    mySessions {
      sessionId
      deviceType
      browser
      os
      ip
      createdAt
      lastSeenAt
    }
  }
`);

export const REVOKE_SESSION = graphql(`
  mutation revokeSession($sessionId: ID!) {
    revokeSession(sessionId: $sessionId) {
      success
      sessionId
    }
  }
`);

export const REVOKE_ALL_OTHER_SESSIONS = graphql(`
  mutation revokeAllOtherSessions($currentSessionId: ID!) {
    revokeAllOtherSessions(currentSessionId: $currentSessionId) {
      success
      revokedCount
    }
  }
`);
